<script  setup>


import moment from 'moment';
import {
    ElCol,
    ElRow,
    ElCard,
    ElText,
    ElButton,
    ElSlider,
    ElCheckboxGroup,
    ElCheckboxButton,
    ElCheckbox,
    ElLoading, FormInstance
} from "element-plus";
import axios from "axios";
import {computed, reactive, ref, watch} from "vue";
import FlightComboDetailsCard from "./FlightComboDetailsCard.vue";
import { moneyTotal, formatMoney, roundMoney } from '../../../../utils/money';

const ruleFormRef = ref()

const props = defineProps({
    flight:Object,
    form:Object

});
const emit = defineEmits(['removeflight']);
const flight=props.flight;
const form=props.form;


const showdetails=ref(false);
const editprice=ref(false);

const momenttime=(date)=>{
    return moment(date).format('HH:mm');
}

const momentdate=(date)=>{
    return moment(date).format('D MMM');
}

const mintoHM=(totalMinutes)=>{
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return hours+"h "+minutes+"m ";
}

const airlineLogoUrl = (airline) => {
    if (airline && airline.logo) {
        return airline.logo;
    }
    return '';
}


const removeflight=(flight)=>{
    emit('removeflight',flight)
}

const editform=reactive(
    {
        "pricing":{
            "total":flight.pricing.total,
            "adult":flight.pricing.adult ,
            "child":flight.pricing.child ,
            "infant":flight.pricing.infant ,
        },
        "refundable":flight.refundable
    }
)



const refreshprice = () => {
    editform.pricing.total=flight.pricing.total;
    editform.pricing.adult=flight.pricing.adult;
    editform.pricing.child=flight.pricing.child;
    editform.pricing.infant=flight.pricing.infant;
    editform.refundable=flight.refundable;

};

const updateupricecount = () => {
    editform.pricing.total = moneyTotal(form.adults, editform.pricing.adult, form.childs, editform.pricing.child, form.infants, editform.pricing.infant);
};
const savePrice = () => {
    flight.pricing.total=roundMoney(editform.pricing.total);
    flight.pricing.adult=roundMoney(editform.pricing.adult);
    flight.pricing.child=roundMoney(editform.pricing.child);
    flight.pricing.infant=roundMoney(editform.pricing.infant);
    flight.refundable=editform.refundable;
    editprice.value=false;
};


const submitForm = async (formEl) => {

    if (!formEl) return
    await formEl.validate((valid, fields) => {

        if (valid) {

            savePrice()

        }
    })
}

watch(
    () => editform.pricing.adult,
    () => {
        updateupricecount();
    }
)

watch(
    () => editform.pricing.child,
    () => {
        updateupricecount();
    }
)

watch(
    () => editform.pricing.infant,
    () => {
        updateupricecount();
    }
)



</script>

<template>
    <el-card class="mt-3">
        <el-row :gutter="40">
            <el-col :span="10">
                <el-row class="flight-card" :gutter="20">
                    <el-col :span="6">
                        <div class="airlines">
                    <span v-for="airline in flight.data.departure.airlines" >
                    <img
                        v-if="airlineLogoUrl(airline)"
                        :src="airlineLogoUrl(airline)"
                        alt=""
                        style="height: 28px; width: auto; max-width: 48px; object-fit: contain;"
                    />
                    {{ airline.name }}&nbsp;
                    </span>
                        </div>
                    </el-col>
                    <el-col :span="6" class="timings text-right">
                <span>
                    <p>
                        <el-text tag="b" size="large">{{ momenttime(flight.data.departure.departure_datetime) }}</el-text>
                    </p>
                     <p>
                        <el-text tag="b" size="small">{{ momentdate(flight.data.departure.departure_datetime) }}</el-text>
                    </p>
                     <p>
                        <el-text tag="b" size="small">{{ flight.data.departure.from.city }}, {{ flight.data.departure.from.code }}</el-text>
                    </p>
                      <p>
                        <el-text  size="small"> {{ flight.data.departure.from.terminal }}</el-text>
                    </p>
                </span>
                    </el-col>
                    <el-col :span="6" class="duration text-center">
                        <p>
                            <el-text tag="b" size="small">{{ mintoHM(flight.data.departure.duration) }}</el-text>
                        </p>
                        <el-divider></el-divider>
                        <p class="stopsinfo">
                            <el-text tag="b" size="small">{{ flight.data.departure.layoverinfo }}</el-text>
                        </p>

                    </el-col>

                    <el-col :span="6" class="timings">
                <span>
                    <p>
                        <el-text tag="b" size="large">{{ momenttime(flight.data.departure.arrival_datetime) }}</el-text>
                    </p>
                     <p>
                        <el-text tag="b" size="small">{{ momentdate(flight.data.departure.arrival_datetime) }}</el-text>
                    </p>
                     <p>
                        <el-text tag="b" size="small">{{ flight.data.departure.to.city }}, {{ flight.data.departure.to.code }}</el-text>
                    </p>
                      <p>
                        <el-text  size="small"> {{ flight.data.departure.to.terminal }}</el-text>
                    </p>
                </span>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="10">
                <el-row class="flight-card" :gutter="20">
                    <el-col :span="6">
                        <div class="airlines">
                    <span v-for="airline in flight.data.return.airlines" >
                    <img
                        v-if="airlineLogoUrl(airline)"
                        :src="airlineLogoUrl(airline)"
                        alt=""
                        style="height: 28px; width: auto; max-width: 48px; object-fit: contain;"
                    />
                    {{ airline.name }}&nbsp;
                    </span>
                        </div>
                    </el-col>
                    <el-col :span="6" class="timings text-right">
                <span>
                    <p>
                        <el-text tag="b" size="large">{{ momenttime(flight.data.return.departure_datetime) }}</el-text>
                    </p>
                      <p>
                        <el-text tag="b" size="small">{{ momentdate(flight.data.return.departure_datetime) }}</el-text>
                    </p>
                     <p>
                        <el-text tag="b" size="small">{{ flight.data.return.from.city }}, {{ flight.data.return.from.code }}</el-text>
                    </p>
                      <p>
                        <el-text  size="small"> {{ flight.data.return.from.terminal }}</el-text>
                    </p>
                </span>
                    </el-col>
                    <el-col :span="6" class="duration text-center">
                        <p>
                            <el-text tag="b" size="small">{{ mintoHM(flight.data.return.duration) }}</el-text>
                        </p>
                        <el-divider></el-divider>
                        <p class="stopsinfo">
                            <el-text tag="b" size="small">{{ flight.data.return.layoverinfo }}</el-text>
                        </p>

                    </el-col>

                    <el-col :span="6" class="timings">
                <span>
                    <p>
                        <el-text tag="b" size="large">{{ momenttime(flight.data.return.arrival_datetime) }}</el-text>
                    </p>
                      <p>
                        <el-text tag="b" size="small">{{ momentdate(flight.data.return.arrival_datetime) }}</el-text>
                    </p>
                     <p>
                        <el-text tag="b" size="small">{{ flight.data.return.to.city }}, {{ flight.data.return.to.code }}</el-text>
                    </p>
                      <p>
                        <el-text  size="small"> {{ flight.data.return.to.terminal }}</el-text>
                    </p>
                </span>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="4">
                <el-dropdown trigger="hover">
                    <el-text tag="b" size="large">₹ {{formatMoney(flight.pricing.total)}} <el-text tag="b" size="small" type="info"  @click="refreshprice();editprice=true">Edit</el-text></el-text>

                    <template #dropdown>
                            <p >
                                Adult - ₹  {{formatMoney(flight.pricing.adult)}}
                            </p>
                        <p v-if="form.childs>0">
                            Child - ₹  {{formatMoney(flight.pricing.child)}}
                        </p>
                        <p v-if="form.infants>0">
                            Infant - ₹  {{formatMoney(flight.pricing.infant)}}
                        </p>
                    </template>
                </el-dropdown>
               <p>
                   <el-text size="small" type="success" v-if="flight.refundable">Refundable</el-text>
                   <el-text size="small" v-else type="danger">Non Refundable</el-text>
               </p>
                <p> <el-text tag="b" size="small" type="warning">{{ flight.data.pricedetails.baggage.checkin }}</el-text>
                </p>
                 <p><el-text tag="ins" @click="showdetails = true">Flight Details</el-text></p>
                <el-button type="danger" size="small" @click="removeflight(flight)" >Remove</el-button>

            </el-col>
        </el-row>
    </el-card>


    <el-dialog
        v-model="showdetails"
        title="Flight Details"
        width="80%"

    >
        <el-text size="small" type="success" v-if="flight.refundable">Refundable</el-text>
        <el-text size="small" v-else type="danger">Non Refundable</el-text>
        <flight-combo-details-card :flight="flight.data.departure"></flight-combo-details-card>
        <br>
        <flight-combo-details-card :flight="flight.data.return"></flight-combo-details-card>

    </el-dialog>

    <el-dialog
        v-model="editprice"
        title="Edit Flight"
        width="50%"

    >
        <el-form
            ref="ruleFormRef"
            :model="editform"
            status-icon
            label-width="auto"
            class="demo-ruleForm"
            label-position="top"
            size="small"

        >
            <el-row :gutter="20">
                <el-col :span="4" >
                    <el-form-item label="Adults" >
                        <el-input v-model="form.adults"  placeholder="Adults" readonly/>
                    </el-form-item>

                </el-col>
                <el-col :span="4" >
                    <el-form-item label="Adult Pricing" prop="pricing.adult" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="editform.pricing.adult"  placeholder="Adult Pricing" type="number" />
                    </el-form-item>

                </el-col>


            </el-row>
            <el-row :gutter="20" v-if="form.childs>0">
                <el-col :span="4" >
                    <el-form-item label="Child" >
                        <el-input v-model="form.childs"  placeholder="Child" readonly/>
                    </el-form-item>

                </el-col>
                <el-col :span="4" >
                    <el-form-item label="Child Pricing" prop="pricing.child" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="editform.pricing.child"  placeholder="Child Pricing"  type="number" />
                    </el-form-item>

                </el-col>


            </el-row>
            <el-row :gutter="20" v-if="form.infants>0">
                <el-col :span="4" >
                    <el-form-item label="Infants" >
                        <el-input v-model="form.infants"  placeholder="Infants" readonly/>
                    </el-form-item>

                </el-col>
                <el-col :span="4" >
                    <el-form-item label="Infants Pricing" prop="pricing.infant" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="editform.pricing.infant"  placeholder="Infants Pricing"  type="number"/>
                    </el-form-item>

                </el-col>


            </el-row>
            <el-row :gutter="20" >
                <el-col :span="4" >


                </el-col>
                <el-col :span="4" >
                    <el-form-item label="Total Pricing" prop="pricing.total" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="editform.pricing.total"  placeholder="Total Pricing"  type="number" readonly/>
                    </el-form-item>

                </el-col>


            </el-row>

            <el-row :gutter="20" >

                <el-col :span="4" >
                    <el-form-item label="Refundable" prop="refundable">
                        <el-switch v-model="editform.refundable">

                        </el-switch>
                    </el-form-item>

                </el-col>


            </el-row>




        </el-form>


        <template #footer>
            <div class="dialog-footer">
                <el-button @click="editprice = false">Cancel</el-button>
                <el-button type="primary" @click="submitForm(ruleFormRef)">
                    Save
                </el-button>
            </div>
        </template>

    </el-dialog>
</template>

<style scoped>

</style>
